import { NSARouterMakerResult } from "namirasoft-account-react";
import { useParams } from "react-router-dom";
import { BalanceEntities } from "../BalanceEntities";
import { BalanceLayout } from "../BalanceLayout";
import { BalanceRouterProps } from "../BalanceRouterProps";
import { AssetProvider } from "../components/AssetProvider";
import { GeneralLedger } from "../components/GeneralLedger";
import { NamirasoftMap } from "namirasoft-site-map";

interface TransactionListPageProps extends NSARouterMakerResult, BalanceRouterProps { }

function TransactionListPage(props: TransactionListPageProps)
{
	let { asset_id } = useParams();
	return (
		<BalanceLayout {...props}
			action={{
				title: "",
				description: "A list of all your transactions. Track each balance entry to monitor your income and expenses across all products and services.",
				menus: {}
			}}
			pages={{
				entity: BalanceEntities.transaction(props, asset_id ?? ""),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				list: {
					ui: {
						default_mode: "General Ledger",
						modes: {
							"General Ledger": {
								show_view: false,
								getChild: () => (
									<AssetProvider
										{...props}
										render={(asset => <GeneralLedger server={props.servers.balance} namirasoft={new NamirasoftMap(props.account.token_manager, console.error)} asset={asset} />)}
									/>
								)
							}
						},
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						}
					}
				}
			}}
		>
			<></>
		</BalanceLayout>
	);
}

export default TransactionListPage;